import classNames from "classnames";
import {observer} from "mobx-react-lite";
import React from "react";
import {KeyValue} from "../../../stores/observables/keyValue";
import {ObservableList} from "../../../stores/observables/observableList";
import EditField from "../editField/editField";
import "./multiselect.sass";

export interface ISingleSelectProp {
  label?: string;
  validationMessage?: string;
  isDisabled?: boolean;
  items: ObservableList<KeyValue>;
  onSelect?: (item: KeyValue) => void;
  orientation?: "grid" | "list";
}

/*
  Single select and multiselect are visually identical, but functionally very different.
  Single select changes the "current" selection when the user clicks
  Multiselect adds/removes to the list of selected values when the user clicks
*/
const SingleSelect: React.FC<ISingleSelectProp> = ({
  label,
  validationMessage,
  isDisabled = false,
  items,
  onSelect,
  orientation = "grid"
}) => {
  const handleClick = (item: KeyValue) => {
    items.setSelectedItem(item.value);
    onSelect?.(item);
  };
  return (
    <EditField
      label={label}
      validationMessage={validationMessage}
      validationMessagePosition="bottom"
      showValidationMessage={!items.isValid}
      isRequired={items.validate !== undefined}
    >
      <div
        data-testid="singleSelect"
        className={classNames(
          "multiselect",
          {error: !items.isValid},
          {vertical: orientation === "list"}
        )}
      >
        {items.items.map((item) => {
          return (
            <button
              key={item.value}
              disabled={isDisabled}
              className={classNames(
                {selected: item.value === items.selectedItem?.value},
                {disabled: isDisabled}
              )}
              onClick={() => handleClick(item)}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </EditField>
  );
};

export default observer(SingleSelect);
